module.exports = __webpack_public_path__ + "scripts/icons.svg?1265f3f7";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/icons.svg
// module id = 945
// module chunks = 1